import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

import {
  ETrialStage,
  formatDaysLeft,
  ITrialState,
  SUBSCRIPTION_ROUTE,
} from '../../../../core/store/user/models/trial';

/**
 * Slim centred bar across the full width of the app, above the sidebar, for the whole
 * trial. Amber while the trial runs, red once it expires. The supporting line pairs the
 * current limit with what upgrading gains, and names no individual scan type, so it reads
 * as an offer and does not go stale when entitlements change.
 */
@Component({
  selector: 'app-trial-banner',
  templateUrl: './trial-banner.component.html',
  imports: [CommonModule, RouterLink],
})
export class TrialBannerComponent {
  @Input() trial: ITrialState | null = null;

  readonly subscriptionRoute = SUBSCRIPTION_ROUTE;

  get accent(): string {
    return this.trial?.stage === ETrialStage.EXPIRED ? '#F04438' : '#FEC84B';
  }

  get headline(): string {
    return this.trial?.stage === ETrialStage.EXPIRED
      ? 'Your Trial plan has expired'
      : `You're on the Trial plan — expires in ${formatDaysLeft(
          this.trial?.daysLeft ?? 0,
        )}`;
  }

  get detail(): string {
    return this.trial?.stage === ETrialStage.EXPIRED
      ? 'Scanning and monitoring are paused. Your existing findings stay available.'
      : 'Trial includes limited scans. Unlock continuous scanning and full monitoring.';
  }
}
